import css from './index.module.scss';
import { useLang } from '@/i18n';
import EfImg from '@elem/ui/ef-img';
import { useEffect, useState } from 'react';
import { Scrollbar } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import Form from './Form';
import type { CooperationProps } from './interface';
import { createPortal } from 'react-dom';
import dynamic from 'next/dynamic';

const SuccessModal = dynamic(() => import('./SuccessModal'), { ssr: false });

const Cooperation: React.FC<CooperationProps> = ({ countryList }) => {
    const { t } = useLang();
    const [activeC, setActiveC] = useState(0);
    const [enter, setEnter] = useState(false);
    const [visible, setVisible] = useState(false);
    const [isClient, setIsClient] = useState(false);

    const cards = [
        {
            img: ['https://websiteoss.ecoflow.com/upload/image/1742376601812/3_1.jpg', 'https://websiteoss.ecoflow.com/upload/image/1742376551357/3_1_M.jpg'],
            name: t('C_item1_name'),
            desc: t('C_item1_desc'),
        },
        {
            img: ['https://websiteoss.ecoflow.com/upload/image/1742376552166/3_2.jpg', 'https://websiteoss.ecoflow.com/upload/image/1742376551772/3_2_M.jpg'],
            name: t('C_item2_name'),
            desc: t('C_item2_desc'),
        },
        {
            img: ['https://websiteoss.ecoflow.com/upload/image/1742376553166/3_3.jpg', 'https://websiteoss.ecoflow.com/upload/image/1742376552771/3_3_M.jpg'],
            name: t('C_item3_name'),
            desc: t('C_item3_desc'),
        },
        {
            img: ['https://websiteoss.ecoflow.com/upload/image/1742376552970/3_4.jpg', 'https://websiteoss.ecoflow.com/upload/image/1742376552576/3_4_M.jpg'],
            name: t('C_item4_name'),
            desc: t('C_item4_desc'),
        },
        {
            img: ['https://websiteoss.ecoflow.com/upload/image/1742376551127/3_5.jpg', 'https://websiteoss.ecoflow.com/upload/image/1742376552387/3_5_M.jpg'],
            name: t('C_item5_name'),
            desc: t('C_item5_desc'),
        },
        {
            img: ['https://websiteoss.ecoflow.com/upload/image/1742376551573/3_6.jpg', 'https://websiteoss.ecoflow.com/upload/image/1742376551976/3_6_M.jpg'],
            name: t('C_item6_name'),
            desc: t('C_item6_desc'),
        },
    ];

    const items = [
        {
            num: 140,
            devide: 14,
            suffix: '+',
            text: t('E_item1_text'),
        },
        {
            num: 5,
            devide: 5,
            suffix: 'M+',
            text: t('E_item2_text'),
        },
        {
            num: 2000,
            devide: 20,
            suffix: '',
            text: t('E_item3_text'),
        },
        {
            num: 45,
            devide: 9,
            suffix: '%',
            text: t('E_item4_text'),
        },
    ];

    const brands = [
        ['https://websiteoss.ecoflow.com/upload/image/1742383733829/6_1.png', 'https://websiteoss.ecoflow.com/upload/image/1742383894296/6_1_M.png'],
        ['https://websiteoss.ecoflow.com/upload/image/1742383732897/6_2.jpg', 'https://websiteoss.ecoflow.com/upload/image/1742383894025/6_2_M.jpg'],
        ['https://websiteoss.ecoflow.com/upload/image/1742383734027/6_3.jpg', 'https://websiteoss.ecoflow.com/upload/image/1742383894506/6_3_M.jpg'],
        ['https://websiteoss.ecoflow.com/upload/image/1742383746457/6_4.png', 'https://websiteoss.ecoflow.com/upload/image/1742383893395/6_4_M.png'],
        ['https://websiteoss.ecoflow.com/upload/image/1742383746290/6_5.png', 'https://websiteoss.ecoflow.com/upload/image/1742383893705/6_5_M.png'],
        ['https://websiteoss.ecoflow.com/upload/image/1742383733614/6_6.png', 'https://websiteoss.ecoflow.com/upload/image/1742383893196/6_6_M.png'],
    ];

    const onMouseEnter = (k: number) => {
        if (k !== activeC) {
            setActiveC(k);
            const target = document.querySelector(`.${css.page} .C .card${k} .card-info`) as HTMLUListElement;
            if (target) {
                target.style.transition = 'none';
                target.style.opacity = '0';
                setTimeout(() => {
                    target.style.transition = 'all 0.4s ease-in-out';
                    target.style.opacity = '1';
                }, 600);
            }
        }
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);

            const observer = new IntersectionObserver((entries: any[]) => {
                entries.forEach((entry: { isIntersecting: any; target: { classList: string[] } }) => {
                    if (entry.isIntersecting && entry.target.classList[0] === 'cooperation-E' && !enter) {
                        setEnter(true);
                    } else {
                        setEnter(false);
                    }
                });
            });
            const sectionB: HTMLDivElement | null = document.querySelector('.cooperation-E');
            if (sectionB) {
                observer.observe(sectionB);
            }
        }
    }, []);

    return (
        <div className={css.page}>
            <div className="cooperation-A banner">
                <EfImg
                    pc={'https://websiteoss.ecoflow.com/upload/image/1742372660366/1.jpg'}
                    h5={'https://websiteoss.ecoflow.com/upload/image/1742372659470/1_M.jpg'}
                />
                <div className="info">
                    <div className="inner">
                        <h1 className="banner-title">{t('A_title')}</h1>
                        <p className="banner-desc">{t('A_desc')}</p>
                    </div>
                </div>
            </div>

            <div className="cooperation-B section">
                <div className="info">
                    <h2 className="title">{t('B_title')}</h2>
                    <p className="desc">{t('B_desc')}</p>
                </div>
                <div className="img-box">
                    <EfImg
                        pc="https://websiteoss.ecoflow.com/upload/image/1742372659963/2.jpg"
                        h5="https://websiteoss.ecoflow.com/upload/image/1742372660150/2_M.jpg"
                    />
                </div>
                <ul className="icons">
                    <li className="icon">
                        <svg className="icon-svg" width="55" height="55" viewBox="0 0 55 55" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M16.8139 13.62C13.1979 16.1019 10.4884 19.8085 9.28329 24.1415M15.4247 43.7669C18.6999 46.4884 22.9089 48.125 27.5 48.125C32.04 48.125 36.2062 46.5248 39.4655 43.8576M45.7441 24.241C44.5378 19.8091 41.7598 16.0251 38.0458 13.5245"
                                stroke="#2673FF"
                                stroke-width="3.5"
                                stroke-linecap="round"
                            />
                            <path
                                d="M32.6251 11.4584C32.6251 14.2888 30.3305 16.5834 27.5001 16.5834C24.6696 16.5834 22.3751 14.2888 22.3751 11.4584C22.3751 8.62791 24.6696 6.33337 27.5001 6.33337C30.3305 6.33337 32.6251 8.62791 32.6251 11.4584Z"
                                stroke="#2673FF"
                                stroke-width="3.5"
                            />
                            <path
                                d="M16.5833 34.3751C16.5833 37.2056 14.2888 39.5001 11.4583 39.5001C8.62788 39.5001 6.33334 37.2056 6.33334 34.3751C6.33334 31.5447 8.62788 29.2501 11.4583 29.2501C14.2888 29.2501 16.5833 31.5447 16.5833 34.3751Z"
                                stroke="#2673FF"
                                stroke-width="3.5"
                            />
                            <path
                                d="M48.6668 34.3751C48.6668 37.2056 46.3722 39.5001 43.5417 39.5001C40.7113 39.5001 38.4167 37.2056 38.4167 34.3751C38.4167 31.5447 40.7113 29.2501 43.5417 29.2501C46.3722 29.2501 48.6668 31.5447 48.6668 34.3751Z"
                                stroke="#2673FF"
                                stroke-width="3.5"
                            />
                        </svg>

                        <p className="icon-text">{t('B_icon1')}</p>
                    </li>
                    <li className="icon">
                        <svg className="icon-svg" width="53" height="53" viewBox="0 0 53 53" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M46.8528 43.3829H9.7888V7.90023C9.7888 7.04179 8.9235 6.18335 7.91395 6.18335C6.90439 6.18335 6.18335 7.04179 6.18335 7.90023V45.0998C6.18335 46.1013 7.04865 46.8167 7.91395 46.8167H46.8528C47.8623 46.8167 48.5834 45.9582 48.5834 45.0998C48.5834 44.2413 47.8623 43.3829 46.8528 43.3829Z"
                                fill="#2673FF"
                            />
                            <path
                                d="M17.2142 34.7807L26.7046 25.2515L31.6623 30.2295C32.3705 30.9406 33.5037 30.9406 34.212 30.2295L45.4022 18.9935C46.1104 18.2823 46.1104 17.1445 45.4022 16.4334C44.694 15.7223 43.5607 15.7222 42.8525 16.4334L32.9372 26.3893L28.1211 21.5536C27.9795 21.4113 27.9795 21.4113 27.8378 21.4113C27.1296 20.7002 25.9964 20.7002 25.2882 21.4113L14.6645 32.3629C13.9563 33.074 13.9563 34.2118 14.6645 34.923C15.3728 35.4919 16.5059 35.4919 17.2142 34.7807Z"
                                fill="#2673FF"
                            />
                        </svg>

                        <p className="icon-text">{t('B_icon2')}</p>
                    </li>
                    <li className="icon">
                        <svg className="icon-svg" width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6.75 45H9.76754H47.25" stroke="#2673FF" stroke-width="3.125" stroke-linecap="round" stroke-linejoin="round" />
                            <path
                                d="M29.25 45V6.75L12.492 14.8552C11.7371 15.2201 11.25 16.0463 11.25 16.9589V45"
                                stroke="#2673FF"
                                stroke-width="3.125"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                            <path
                                d="M45.0001 45V31.4507C45.0001 30.6657 44.5895 29.9329 43.9064 29.5023L29.2501 20.25"
                                stroke="#2673FF"
                                stroke-width="3.125"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                            <path d="M15.7501 22.5001H24.7501" stroke="#2673FF" stroke-width="3.125" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M15.7501 29.2501H24.7501" stroke="#2673FF" stroke-width="3.125" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M15.7501 36H24.7501" stroke="#2673FF" stroke-width="3.125" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M33.7499 36H40.4999" stroke="#2673FF" stroke-width="3.125" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <p className="icon-text">{t('B_icon3')}</p>
                    </li>
                </ul>
            </div>

            <div className="cooperation-C section">
                <div className="info">
                    <h2 className="title">{t('C_title')}</h2>
                </div>
                <ul className="card-box">
                    {cards?.map((card: any, k: number) => (
                        <li className={`card card${k} ${k === activeC ? 'active' : ''}`} key={k} onMouseEnter={() => onMouseEnter(k)}>
                            <div className="card-img">
                                <EfImg pc={card?.img[0]} />
                            </div>
                            <div className="card-info">
                                <p className="card-title">{card?.name}</p>
                                <p className="card-desc">{card?.desc}</p>
                            </div>
                        </li>
                    ))}
                </ul>
                <Swiper
                    className="swiper-box-C"
                    effect="fade"
                    modules={[Scrollbar]}
                    spaceBetween={16}
                    slidesPerView={'auto'}
                    initialSlide={0}
                    scrollbar={{
                        hide: false,
                        draggable: true,
                        dragSize: 25,
                        snapOnRelease: true,
                    }}
                >
                    {cards?.map((item: any, k: number) => (
                        <SwiperSlide className={`swiper-item item-${k + 1}`} key={k}>
                            <div className="item-img">
                                <EfImg pc={item.img[1]} />
                            </div>
                            <div className="item-text">
                                <p className="item-title">{item.name}</p>
                                <p className="item-desc">{item.desc}</p>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>

            <div className="cooperation-D section">
                <EfImg
                    pc="https://websiteoss.ecoflow.com/upload/image/1742377043477/4.jpg"
                    h5="https://websiteoss.ecoflow.com/upload/image/1742377043638/4_M.jpg"
                />
            </div>

            <div className="cooperation-E section">
                <div className="info">
                    <h2 className="title">{t('E_title')}</h2>
                </div>
                <ul className={`items${enter ? ' enter' : ''}`}>
                    {items?.map((item: any, k: number) => (
                        <li className="item" key={k}>
                            <div className="item-ani">
                                <ul
                                    className="item-arr"
                                    style={{
                                        transform: enter ? `translateY(-${(item.devide - 1) * 100}%)` : 'none',
                                        transitionDuration: enter ? `${item.devide * 0.2}s` : '.2s',
                                    }}
                                >
                                    {Array.from({ length: item.devide }, (_, i) => (i + 1) * (item.num / item.devide))?.map((num: number, m: number) => (
                                        <li className="item-li" key={k + '_' + m}>
                                            {String(num).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                        </li>
                                    ))}
                                </ul>
                                {item?.suffix && <span className="item-suffix">{item.suffix}</span>}
                            </div>
                            <p className="item-text">{item.text}</p>
                        </li>
                    ))}
                </ul>
            </div>

            <div className="cooperation-F section">
                <div className="info">
                    <h2 className="title">{t('F_title')}</h2>
                </div>
                <ul className="brands">
                    {brands?.map((brand: string[], k: number) => (
                        <li className={`brand brand${k + 1}`} key={k}>
                            <EfImg pc={brand[0]} h5={brand[1]} />
                        </li>
                    ))}
                </ul>
            </div>

            <div className="cooperation-G section">
                <Form countryList={countryList} callback={() => setVisible(true)} />
            </div>
            {visible && isClient && createPortal(<SuccessModal callback={() => setVisible(false)} />, document.body)}
        </div>
    );
};

export default Cooperation;
